import React, { useState } from "react";
import { Cta } from "../../elements/Cta/Cta";
import * as styles from "./LoginForm.module.css";
import * as ctaStyles from "../../elements/Cta/Cta.module.css";
import { LoginFormStyle } from "./LoginForm";

interface Props extends LoginFormStyle {
  prefix?: string;
}

export const DigitalBankingForm: React.FC<Props> = ({
  style = "light",
  prefix = "",
}) => {
  const [showHelp, setShowHelp] = useState(false);

  const handleHelpButtonClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    setShowHelp(true);
  };

  return (
    <div className={styles.form}>
      <form
        method="post"
        action="https://onlinebanking.emprisebank.com/authorize"
        target="_parent"
      >
        <div className={styles.form}>
          <label htmlFor={`${prefix}digbank_userId`} className="vis-hidden">
            User Id
          </label>
          <input
            type="text"
            id={`${prefix}digbank_userId`}
            name="j_username"
            placeholder="User ID"
          />
          <label htmlFor={`${prefix}digbank_Password`} className="vis-hidden">
            Password
          </label>
          <input
            type="password"
            name="j_password"
            id={`${prefix}digbank_Password`}
            placeholder="Password"
          />
          {showHelp ? (
            <div className={styles.helpLinks}>
              <p>
                <a
                  target="_blank"
                  href="https://onlinebanking.emprisebank.com/forgot_userid"
                >
                  Forgot Username?
                </a>{" "}
                |{" "}
                <a
                  target="_blank"
                  href="https://onlinebanking.emprisebank.com/forgot_password/user_info"
                >
                  Forgot Password?
                </a>
              </p>
              <p>
                <a
                  target="_blank"
                  href="https://onlinebanking.emprisebank.com/unlock_account"
                >
                  Unlock Account
                </a>
              </p>
            </div>
          ) : (
            <button
              className={styles.helpButton}
              type="button"
              onClick={(e) => handleHelpButtonClick(e)}
            >
              Need help?
            </button>
          )}
          <button
            value="Login"
            type="submit"
            className={[
              ctaStyles.cta,
              style === "light" ? ctaStyles.white : "",
            ].join(" ")}
          >
            Submit
          </button>
        </div>
      </form>
      <div
        className={[
          styles.separator,
          style === "light" ? "" : styles.darkSeparator,
        ].join(" ")}
      >
        &nbsp;&nbsp;or&nbsp;&nbsp;
      </div>
      <Cta
        label="Enroll"
        buttonStyle={style === "light" ? "white" : undefined}
        href="https://onlinebanking.emprisebank.com/enrollment/terms_and_condition"
      />

      {/* <p align="center"><strong><font color="red">Digital banking is currently unavailable. Technicians are working to resolve the issue.</font></strong></p> --> */}
      {/* <div class="login-expand-links">
                <a id="personal-username" class="s-link ga-event" data-title="Digital Banking Login - Forgot Username" target="_blank" href="https://onlinebanking.emprisebank.com/forgot_userid">Forgot Username?</a>
                  <span>|</span>
                <a id="personal-password" class="s-link ga-event" data-title="Digital Banking Login - Forgot Password" target="_blank" href="https://onlinebanking.emprisebank.com/forgot_password/user_info">Forgot Password?</a><br>
                <a id="personal-unlock" class="s-link ga-event" data-title="Digital Banking Login - Unlock Account" target="_blank" href="https://onlinebanking.emprisebank.com/unlock_account">Unlock Account</a>
                  <span>|</span>
              </div> */}
    </div>
  );
};
